import React, { useEffect, useRef, useState } from "react";
import alternateInstruments from "../../assets/images/svg/alternateInstruments.svg";
import moneyBag from "../../assets/images/svg/moneyBag.svg";
import infinityQuickView from "../../assets/images/svg/infinityQuickView.svg";
import equity from "../../assets/images/svg/equity.svg";
import fixedIncome from "../../assets/images/svg/fixedIncome.svg";
import QuickViewsSub from "../QuickViewsSub/QuickViewsSub";
import QuickViewButton from "../QuickViewsButton/QuickViewButton";
import UserStore from "../../store/UserStore";
import { observer } from "mobx-react";

const QuickViews = observer(() => {
  const scrollableDivRef = useRef();
  const [scrollValue, setScrollValue] = useState(0);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const dispImg = {
    2: equity,
    3: moneyBag,
    4: fixedIncome,
    5: alternateInstruments,
    0: infinityQuickView,
  };

  const styleProp = {
    2: {
      //equity
      width: "51px",
      height: "72px",
    },
    3: {
      //money
      width: "50px",
      height: "60px",
    },
    4: {
      //fixed
      width: "51px",
      height: "67px",
    },
    5: {
      //alternative
      width: "78px",
      height: "60px",
    },
    0: {
      //alternative
      // width: "78px",
      height: "63px",
    },
  };

  const scrollTo = (scrollDirection) => {
    if (scrollDirection === "next") {
      scrollableDivRef.current.scrollLeft += 350;
    } else {
      scrollableDivRef.current.scrollLeft -= 350;
    }
  };

  const getQuick = () => {
    let total = UserStore?.clientQuickviews?.reduce((acc, cur) => {
      return (acc = acc + Number(cur?.instrumentCount));
    }, 0);
    return total;
  };

  useEffect(() => {
    if (
      scrollableDivRef?.current?.scrollWidth -
        scrollableDivRef?.current?.clientWidth -
        Math.round(scrollValue) <
      5
    ) {
      setIsNextDisabled(true);
    } else {
      setIsNextDisabled(false);
    }
  }, [scrollValue]);

  useEffect(() => {
    setScrollValue(scrollableDivRef?.current?.scrollLeft);
  }, [scrollableDivRef?.current?.scrollLeft]);

  return (
    <div className={getQuick() !== 0 ? "quick_outside" : ""}>
      <div className="quick_inside_main">
        {getQuick() !== 0 && (
          <>
            {" "}
            <h2 className="quick_heading">Quick Views</h2>
            <div className="quick_container_wrapper">
              <div
                className="quick_container"
                ref={scrollableDivRef}
                onScroll={(e) => setScrollValue(e.target.scrollLeft)}
              >
                {scrollValue ? (
                  <div className="quick_btn_container left">
                    <QuickViewButton onClick={() => scrollTo("prev")} />
                  </div>
                ) : null}
                {UserStore?.clientQuickviews
                  ?.filter((item) => item.instrumentCount !== "0")
                  ?.map((view) => {
                    return (
                      <QuickViewsSub
                        styleProps={styleProp[view.instrumentTypeId]}
                        dispImg={dispImg[view.instrumentTypeId]}
                        dispMsgUrl={`${view.instrumentCount} instruments in ${view.instrumentType}`}
                        dispMsg={`Show my ${
                          view.instrumentCount !== "1"
                            ? view.instrumentCount
                            : ""
                        } ${view.instrumentType}`}
                        alt={view.instrumentType}
                        id={{
                          type: view.instrumentType,
                          id: view.instrumentTypeId,
                        }}
                        navigateto={`${view.instrumentType}`}
                        instrumentType={view.instrumentType}
                        instrumentCount={view.instrumentCount}
                      />
                    );
                  })}

                {!isNextDisabled && (
                  <div className="quick_btn_container right">
                    <QuickViewButton onClick={() => scrollTo("next")} />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
});

export default QuickViews;
